<template>
  <div class="text--primary">
    <div v-if="loading">
      <px-circular-loading/>
    </div>
    <div v-if="!loading && !cotacoesProdutos.length">
      <v-card-text>
        Nenhuma cotação encontrada
      </v-card-text>
    </div>
    <v-simple-table v-if="!loading && cotacoesProdutos.length" class="rounded-card mb-3">
      <template v-slot:default>
        <thead>
        <tr>
          <th>Identificador</th>
          <th>Data cotação</th>
          <th>Quantidade</th>
          <th></th>
        </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in cotacoesProdutos" :key="index">
            <td>
              <px-situacao-cotacao-icon :situacao="item.situacao"/>
              {{ item.cotacao.identificador }}
              <px-span-tooltip
                v-if="item.cotacao.codigoInterno"
                bottom
                text-class="caption"
                :text="`(${item.cotacao.codigoInterno})`"
                tooltip="Código no ERP"/>
            </td>
            <td>
              {{ item.cotacao.createdIn | date }}
            </td>
            <td>
              {{ item.quantidade }} {{ item.unidadeMedida.descricao }}
            </td>
            <td>
              <px-cotacao-resposta-dialog-view :cotacao-id="item.cotacao.id" />
              <v-btn icon target="_blank" link :to="`/cotacao/${item.cotacao.id}/respostas`">
                <v-icon>mdi-open-in-new</v-icon>
              </v-btn>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
import CotacoesProdutosService from '@/modules/cotacao/cotacoes-produtos/cotacoes-produtos-service';

export default {
  props: {
    produto: {
      type: Object,
      required: true,
    },
    maxCotacoes: {
      type: Number,
      default: 5,
    },
  },
  data() {
    return {
      loading: false,
      cotacoesProdutos: [],
    };
  },
  methods: {
    getCotacoesProdutos() {
      this.loading = true;
      // situacaoCompra not in ('RECUSADA', 'CANCELADA', 'RASCUNHO')
      const query = `produto.id = ${this.produto.id} order by cotacao.createdIn desc`;
      CotacoesProdutosService.getCotacoesProdutos({ query, limit: this.maxCotacoes })
        .then(({ data }) => {
          this.cotacoesProdutos = data.content;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.getCotacoesProdutos();
  },
  components: {
    pxCotacaoRespostaDialogView: () => import('@/modules/cotacao/resposta/views/modal/CotacaoRespostaDialogView.vue'),
  },
};
</script>
